import { render, staticRenderFns } from "./VUserGroup.vue?vue&type=template&id=95f0e3f4&scoped=true"
import script from "./VUserGroup.vue?vue&type=script&lang=ts"
export * from "./VUserGroup.vue?vue&type=script&lang=ts"
import style0 from "./VUserGroup.vue?vue&type=style&index=0&id=95f0e3f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f0e3f4",
  null
  
)

export default component.exports